import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { type Brokerage } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function getRelevantBrokeragesQueryKey () {
  return ['brokers', 'relevant_brokerages']
}

export function useGetRelevantBrokerages () {
  return useQuery<Brokerage[], GrapeAPIErrorType>({
    queryKey: getRelevantBrokeragesQueryKey(),
    queryFn: async () => {
      const response = await fetchWithHeaders(
        '/api/web/brokers/relevant_brokerages'
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
